const config = {
  Urls: {
    BaseUrl : `${process.env.REACT_APP_API_URL}/api/v1`,
  },
  AzureAd : {
    ClientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    TenantId: process.env.REACT_APP_AZURE_TENANT_ID,
    RedirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
    Scopes: ['User.Read'],
  }
};

export default config;
